import React from "react";
import { StatusBadge } from "@/components/common/DashboardBits";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Card, CardContent } from "@/components/ui/card";
import { Eye, Trash2, Paperclip } from "lucide-react";

const HEADERS = ["Customer", "Bank", "Pincode", "Location", "Type", "TAT", "Executive", "Status"];

function LeadRow({ lead: l, onView, onDelete }) {
  return (
    <TableRow data-testid={`lead-row-${l.id}`}>
      <TableCell className="font-medium">
        <div className="flex items-center gap-1.5">
          {l.customer_name}
          {l.document_count > 0 && (
            <span className="inline-flex items-center gap-0.5 text-[11px] font-normal text-slate-500 bg-slate-100 rounded-full px-1.5 py-0.5" title={`${l.document_count} document(s) attached`} data-testid={`lead-doc-count-${l.id}`}>
              <Paperclip className="h-3 w-3" />{l.document_count}
            </span>
          )}
        </div>
      </TableCell>
      <TableCell className="text-slate-600">{l.bank_name}</TableCell>
      <TableCell className="num text-slate-600">{l.pincode || "—"}</TableCell>
      <TableCell className="text-slate-600">{l.city ? `${l.city}, ${l.location}` : l.location}</TableCell>
      <TableCell className="text-slate-600 capitalize">{l.valuation_type}</TableCell>
      <TableCell className="num text-slate-600">{l.tat_hours}h</TableCell>
      <TableCell className="text-slate-600">{l.executive_name || "—"}</TableCell>
      <TableCell><StatusBadge status={l.status} /></TableCell>
      <TableCell className="text-right">
        <Button variant="ghost" size="sm" onClick={() => onView(l)} data-testid={`view-lead-${l.id}`}><Eye className="h-4 w-4" /></Button>
        {onDelete && (
          <Button variant="ghost" size="sm" onClick={() => onDelete(l)} data-testid={`delete-lead-${l.id}`} className="text-red-600 hover:text-red-700"><Trash2 className="h-4 w-4" /></Button>
        )}
      </TableCell>
    </TableRow>
  );
}

export default function LeadsTable({ leads, actionsLabel, onView, onDelete }) {
  return (
    <Card className="border border-slate-200">
      <CardContent className="p-0 overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {HEADERS.map((h) => <TableHead key={h}>{h}</TableHead>)}
              <TableHead className="text-right">{actionsLabel}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {leads.length === 0 && <TableRow><TableCell colSpan={9} className="text-center text-slate-500 py-10">No leads yet.</TableCell></TableRow>}
            {leads.map((l) => <LeadRow key={l.id} lead={l} onView={onView} onDelete={onDelete} />)}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
